import {
  IconCase,
  IconClinical,
  IconClinicalTrial,
  IconDefaultType,
  IconEditorial,
  IconGuideline,
  IconLetter,
  IconMeta,
  IconMultiCenter,
  IconRCT,
  IconReview,
} from '@/components/IconFont';
import React from 'react';

interface IIProps {
  arr: string[];
}

const DeterminePublishType: React.FC<IIProps> = ({ arr = [] }) => {
  const arrList = arr.map((e) => e.toLocaleLowerCase());
  const meta = arrList.some((e) => e.includes('meta'));
  const trial = arrList.some((e) => e.includes('trial'));
  const guideline = arrList.some((e) => e.includes('guide'));
  const multi = arrList.some((e) => e.includes('multi'));
  const random = arrList.some((e) => e.includes('random'));
  const edt = arrList.some((e) => e.includes('editorial'));
  const letter = arrList.some((e) => e.includes('letter'));
  const review = arrList.some((e) => e.includes('review'));
  const clinical = arrList.some((e) => e.includes('clinical'));
  const caseReports = arrList.some((e) => e.includes('case'));
  if (meta) return <IconMeta />;
  if (guideline) return <IconGuideline />;
  if (review)
    return (
      <span style={{ color: '#595959' }}>
        <IconReview />
      </span>
    );
  if (multi) return <IconMultiCenter />;
  if (random) return <IconRCT />;
  if (trial) return <IconClinicalTrial />;
  if (caseReports) return <IconCase />;
  if (clinical) return <IconClinical />;
  if (edt) return <IconEditorial />;
  if (letter) return <IconLetter />;
  return <IconDefaultType />;
};

interface IProps {
  arr: string[];
  className?: string;
}

const Avatar: React.FC<IProps> = ({ arr = [], className }) => (
  <span className={className}>
    <DeterminePublishType arr={arr} />
  </span>
);

export default Avatar;
